import {MouseEvent} from "react";
import {Modal as BaseModal} from 'react-responsive-modal'
import './Modal.css'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {SpacialFn, styled} from '@yosmanyga/web-style'
import {ModalProps} from '@yosmanyga/primitive-ui-spec'
import Container from './Container'

const Modal = ({
  width, z, onClose,
  className, children
}: ModalProps & UnnormalizedStyleProps) => {
  width = SpacialFn.normalizeWidth(width)

  return <BaseModal
    open={true}
    onClose={onClose}
    onOverlayClick={(e: MouseEvent<HTMLDivElement>) => {
      e.stopPropagation()
    }}
    showCloseIcon={false}
    onAnimationEnd={() => {
      // Not needed anymore on v5
      // Tooltip.rebuild()
    }}
    styles={{
      root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: z || 9999
      },
      overlay: {
        background: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1
      },
      modalContainer: {
        height: '100%',
        outline: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        textAlign: 'center'
      },
      modal: {
        position: 'relative',
        width: width?.def,
        maxWidth: width?.max,
        display: 'inline-block',
        verticalAlign: 'middle',
        overflowY: 'hidden',
        textAlign: 'start'
      }
    }}
    classNames={{
      modal: className
    }}
  >
    <Container
      flow={{
        direction: 'row',
        wrap: true
      }}
      align={{
        main: 'flex-start'
      }}
    >
      {children}
    </Container>
  </BaseModal>
}

const StyledModal = styled(Modal)`
  ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
`

export default StyledModal
